import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  iconError,
  checkPermision,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import LoadingFetchData from "../../utility/LoadingFetchData";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import {
  addModelMaster,
  editModelMaster,
  editProductMaster,
  removeModelMaster,
  removeProductMaster,
  selectPermissionModel,
} from "./ProductRelatedSlice";
import { FormHelperText, TextField } from "@material-ui/core";
// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const ModelMasterTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const permission = useSelector(selectPermissionModel);

  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    // Add number
    const pageBefore = sizePerPage * (page - 1);
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1 + pageBefore,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);

  const handleDelete = async (e, row) => {
    const params = { modelmaster_id: `${row.modelmaster_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeModelMaster({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          {/* <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
          >
            <a
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
              onClick={() => {
                history.push(
                  `/administration/office-management/view/${row.office_id}`
                );
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG
                  src={toAbsoluteUrl( "/media/svg/icons/New/Search.svg")}
                />
              </span>
            </a>
          </OverlayTrigger> */}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={(e) => {
                      setFormValues({
                        modelmaster_id: {
                          value: row.modelmaster_id,
                          error: false,
                          required: "Y",
                        },
                        modelmaster_code: {
                          value: row.modelmaster_code,
                          error: false,
                          required: "Y",
                        },
                        modelmaster_name: {
                          value: row.modelmaster_name,
                          error: false,
                          required: "Y",
                        },
                      });
                      setShow(true);
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "DELETE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                   onClick={(e) =>
                      handleDelete(e, row )
                    }
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Disabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleDisabled(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/New/eye-slash.svg"
                        )}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
              {row.is_enable === "N" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Enabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleEnable(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      modelmaster_id: row.modelmaster_id,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to disabled?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editModelMaster(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      modelmaster_id: row.modelmaster_id,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to enable?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editModelMaster(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      style: { width: "50px" },
      headerAlign: "center",
    },
    {
      text: "Code",
      dataField: "modelmaster_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Name",
      dataField: "modelmaster_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      style: { minWidth: "200px" },
      align: "center",
      headerAlign: "center",
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const [formValues, setFormValues] = useState({
    modelmaster_code: {
      value: "",
      error: false,
      required: "Y",
    },
    modelmaster_name: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const handleSave = async () => {
    if (
      formValues.modelmaster_code.value.includes("<script>") ||
      formValues.modelmaster_code.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (
      formValues.modelmaster_name.value.includes("<script>") ||
      formValues.modelmaster_name.value.includes("</script>")
    ) {
      return showErrorDialog("please don't input value <script>");
    }

    if (!validatePost()) {
      return;
    }

    const params = {
      modelmaster_id: formValues.modelmaster_id.value,
      modelmaster_code: formValues.modelmaster_code.value,
      modelmaster_name: formValues.modelmaster_name.value,
    };

    try {
      const response = await dispatch(editModelMaster(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDuplicate = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      modelmaster_code: formValues.modelmaster_code.value,
      modelmaster_name: formValues.modelmaster_name.value,
    };

    try {
      const response = await dispatch(addModelMaster(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleClose();
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      modelmaster_id: {
        value: "",
        error: false,
        required: "Y",
      },
      modelmaster_code: {
        value: "",
        error: false,
        required: "Y",
      },
      modelmaster_name: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setShow(false);
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="product_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}

      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Update Model Master
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <div>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    required
                    label="Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="modelmaster_code"
                    value={formValues.modelmaster_code.value}
                    onChange={handleChange}
                    error={formValues.modelmaster_code.error}
                    helperText={
                      formValues.modelmaster_code.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  <RedditTextField
                    required
                    label="Name"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="modelmaster_name"
                    value={formValues.modelmaster_name.value}
                    onChange={handleChange}
                    error={formValues.modelmaster_name.error}
                    helperText={
                      formValues.modelmaster_name.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {iconError} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                </Col>
              </Row>
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="outline-primary" onClick={handleDuplicate}>
            Duplicate
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
